import React from "react";
import Contact from "../sections/Contact.jsx";
export default function PageContact() { return <Contact />; }
